export const PERSONAL_DATA_POLICY_LINK = '/documents/personal_data_processing_policy.pdf';
